import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Frente a una persona sorda, te bloqueás',
    costo: 'Una oportunidad de conexión humana perdida para siempre'
  }, {
    sin: 'Videos de YouTube sin orden ni sistema',
    costo: 'Meses de tiempo sin avanzar'
  }, {
    sin: 'Material genérico que no es LSA argentino',
    costo: 'Señas que no sirven en Argentina'
  }, {
    sin: 'Sin entender la gramática visual del LSA',
    costo: 'Sabés señas pero no podés comunicarte'
  }, {
    sin: 'Sin frases listas para situaciones reales',
    costo: 'Te congelás justo cuando más lo necesitás'
  }, {
    sin: 'Sin sistema de práctica',
    costo: 'Aprendés, olvidás, empezás de nuevo el mismo ciclo'
  }];
  return <section className="py-20 bg-slate-900 text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-49">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-slate-400 uppercase text-sm tracking-wider" data-id="element-53">
                Sin CentralPack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                Costo real
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-slate-800/50 rounded-xl p-4 items-center border border-slate-700/50" data-id="element-56">
                  <div className="text-slate-300 font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-slate-500 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-blue-600 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-60">
          <p className="text-xl md:text-2xl font-medium text-blue-100 mb-4" data-id="element-61">
            El próximo encuentro con una persona sorda puede ser diferente.
          </p>
          <p className="text-3xl md:text-4xl font-black text-white" data-id="element-62">
            "La próxima vez, vas a poder comunicarte." 🤟🇦🇷
          </p>
        </motion.div>
      </div>
    </section>;
}